import { OccupierRentType } from '@/bundles/Occupier/interfaces';
import { getDefaultPermissions } from '@/bundles/App/helpers';
import { defaultMapStyle } from '@/bundles/Map/helpers/defaultMapStyle';
import { RentScheduleTypeEnum } from '@/bundles/Comparables/types';

export const DEFAULT_DATE_DISPLAY_FORMAT = 'M/D/YYYY';
export const DEFAULT_DATE_PICKER_FORMAT = 'MM/DD/YYYY';

export const getInitialState = () => ({
  idToken: null,
  // a sign-out is under way: it leaves the page before the session is cleared
  isLoggingOut: false,
  otpRequireDialog: true,
  adminToken: null,
  adminTokenExpiresTime: null,
  appToken: null,
  userId: null,
  // Declared here, not only assigned by SET_CURRENT_USER / LOGIN / AUTH_USER:
  // a property added to an already-observed object is not reactive in Vue 2,
  // so watchers on these two never fired. Both are already persisted paths.
  userName: null,
  userEmail: null,
  contactId: null,
  user: null,
  color: null,
  company: null,
  nav: false,
  isMiniNav: true,
  roles: [],
  availabilityView: 'availabilityClient',
  dealView: 'client',
  appVersion: null,
  spatial: {
    zoom: 15,
    center: {
      longitude: 0,
      latitude: 0,
    },
    markets: [],
    marketLayers: [],
    mapLayers: [],
    industrialLayers: [],
    officeLayers: [],
    retailLayers: [],
    multiFamilyLayers: [],
    markerLayers: [],
    packageLayers: [],
    farmAndRanchLayers: [],
    laborLayers: [],
    residentialLayers: [],
    transportationLayers: [],
    propertyGroupingLayers: [],
    municipalLayers: [],
    style: null,
    styleApprove: 'satellite',
    mapCards: defaultMapStyle.value,
    prevUrl: null,
  },
  cardMap: {
    style: defaultMapStyle.value
  },
  pressRelease: {
    includeOtherAgents: true,
  },
  search: {
    occupier: {
      keyword: '3m ',
    },
    pipeline: {
      category: '',
      keyword: '',
      showClosedWonLost: false,
      showClosedConstructionPending: true,
    },
    property: {
      keyword: '',
    },
    availability: {
      keyword: '',
    },
    contact: {
      keyword: '',
    },
    company: {
      keyword: '',
    },
    requirement: {
      keyword: '',
    },
    comparable: {
      keyword: '',
    },
    deals: {
      keyword: '',
    },
  },
  userRoles: [],
  userPermissions: [],
  socketConnected: false,
  socketStuff: {
    pipeline: {
      updated: false,
    },
  },
  splash: true,
  userSettings: false,
  imagesExtensions: ['png', 'jpg', 'jpeg'],
  snackbar: {
    open: false,
    message: '',
  },
  scheduleTypes: [
    { text: RentScheduleTypeEnum.new, value: RentScheduleTypeEnum.new },
    { text: RentScheduleTypeEnum.renewal, value: RentScheduleTypeEnum.renewal },
    { text: RentScheduleTypeEnum.modification, value: RentScheduleTypeEnum.modification },
    { text: RentScheduleTypeEnum.expansion, value: RentScheduleTypeEnum.expansion },
    { text: RentScheduleTypeEnum.extension, value: RentScheduleTypeEnum.extension },
  ],
  commonItems: {
    leaseType: ['Gross', 'NNN'],
    agencyType: ['Exclusive', 'Non-Exclusive', 'Owner Listed', 'Pocket'],
    availabilityType: ['sale', 'lease'],
    availabilityStatus: ['Active', 'Active (Internal)', 'Pending', 'Inactive'],
    priceAs: ['Total Price', 'Per Square Foot'],
  },
  selectedItems: [],
  isMultipleAccountAuth: false,
  temporaryAuthToken: null,
  temporaryUserInfo: null,
  activeAccount: null,
  accountSettings: {
    email_sender: '',
    email_logo: '',
    email_footer: '',
    pressReleaseDefaults: {},
    emailBlastDefaults: {},
    account: 0,
    accounting_method: '',
    accounting_fiscal_year_ending: '',
    map: {},
    report_settings: {
      property_types: [],
      property_covers: [],
      report_map_style: 'lee-dfw-streets',
    },
    occupier_default_rent_type: OccupierRentType.per_year,
    permissions: getDefaultPermissions(),
    date_display_format: DEFAULT_DATE_DISPLAY_FORMAT,
    date_picker_format: DEFAULT_DATE_PICKER_FORMAT,
    marketing_directives: [],
    country: 'us',
  },
  accountPreferences: {
    company_placeholder: null,
    contact_placeholder: null,
    marker_color: null,
    primary_color: null,
    property_placeholder: null,
    secondary_color: null,
    custom_marker: null,
  },
  userIntegrations: [],
  visitorId: null,
  cancelTokens: [],
  vexcelSatellite: {
    enabled: false,
    streets: false,
    satelliteFallback: false,
  },
  isPasswordTemporary: false,
});
